<template>
 <div>
   <header-sales></header-sales>
   <div id= "subheader">   </div> 
   <div id= "main-container"> 
     <div id= "label-container">
       <span id="label">Promociones</span>
     </div> 
     <div id= "container">
       <div id="list-container">
         <item-promocion id="list-prod" v-for="item in items" :item='item' @setItemPromocion="setPromo"></item-promocion>
       </div>
     </div> 
     <div id="btnContainer">
       <button id="btnIrCarrito" @click="btnIrCarrito">IR AL CARRITO</button>
     </div> 
   </div> 
   <transition name="fadePro"> 
   <div v-show='showPopup'>
     <div id='back-popup'>
     </div>
     <div id='popup'>
       <div id='popup-btnClose-container'>
        <img id='btnClose' v-on:click="btnCerrarPopup" src="/dist/btnClose.png" style="width: 20px;height: 20px">
       </div>
       <p id='popup-titulo'>Ver Promoción</p>
       <div id='popup-container'> 
         <div id='popup-image-container'>
            <img id="imagenProducto" :src="imagenProducto" v-show='imagenProducto != null'/> 
         </div>
         <div class="fv lt" style="margin-top: 20px; color: #5C666F;">
           <div class="fh lc" style="font-size: 14px; font-weight: 600;"> {{nombrePromo}} </div> 
           <div class="fh lc" style="font-size: 12px; font-weight: 500;"> {{descripcionPromo}} </div> 
           <div class="fh lc" style="margin-top: 20px;font-size: 21px; font-weight: 500;"> {{moneyLabel}}{{precioPromo | formatMoney}} </div> 
           <div class="fh lt" style="margin-top: 20px; width: 210px; font-size: 14px; font-weight: 600"> 
               <div class="fv lt" style="width: 50%; font-size: 14px; font-weight: 400;"> 
                 <div class="fh lc" style="margin-top: 5px; font-size: 11px; font-weight: 500;"> CANTIDAD </div> 
                 <p style="font-size: 8px; font-weight: 400; color:#5C666F" v-show='limitePromo'>(max {{limiteMaxCantPromo}} packs)</p> 
                 <div :class='{popupMaximoPorcentaje:pesoMinimoOk,popupMaximoPorcentajeInv:!pesoMinimoOk}' v-show=showPesoPromo>
                    Peso minimo: {{pesoMinimo}}Kg
                 </div>
                 <div :class='{popupMaximoPorcentaje:pesoMinimoOk,popupMaximoPorcentajeInv:!pesoMinimoOk}' v-show=showPesoPromo>
                    (Peso actual: {{cantidadProducto*pesoPromo}}Kg)
                 </div>
               </div> 
               <div class="fv lt" style="width: 50%; font-size: 14px; font-weight: 600;"> 
                 <input :class='{popupCantidad:cantValida,popupCantidadInv:!cantValida}' type="text" value="1" v-model='cantidadProducto' v-on:keyup="updateCantidad">
                 <div class="fv lt" style="margin-top: 2px; font-size: 8px; font-weight: 400;"> 
                    <div :class='{popupMaximoPorcentaje:esMultiploValido,popupMaximoPorcentajeInv:!esMultiploValido}' v-show=tieneUnidadDePedido>
                        (Debe ser múltiplo de {{unidadesPorPedido}})
                    </div>
                    <div class='popupMaximoPorcentajeInv' v-show=!esMultiploValido>
                        {{valorCercano}}
                    </div>
                 </div> 
               </div> 
           </div> 
           <div class="fh lc" style="margin-top: 20px; width: 210px; font-size: 14px; font-weight: 600"> 
               <div class="fv lc" style="width: 50%; font-size: 14px; font-weight: 600;"> 
                 <div class="fh lc" style="font-size: 11px; font-weight: 500;"> SUBTOTAL </div> 
               </div> 
               <div class="fv lc" style="width: 50%; font-size: 14px; font-weight: 600;"> 
                   <div class="fh lc" style="font-size: 13px; font-weight: 600;"> 
                       {{moneyLabel}}{{cantidadProducto*precioPromo  | formatMoney}}
                   </div> 
               </div> 
           </div> 
         </div>
       </div>
       <div id="btnContainerPopup">
         <button @click="btnCerrarPopup"  id="btnCerrarPopup">CANCELAR</button>
         <button @click="btnAgregarPopup" id="btnAgregarPopup">AGREGAR AL CARRITO</button>
       </div> 
     </div> 
   </div> 
  </transition>
 </div>
</template>
      
      
<script>
import HeaderSales from '@components/views/header.vue';
import ItemPromocion from '@components/views/promociones/itemPromociones.vue';
      
export default {
  name: 'Promociones',
  components:{
    'header-sales': HeaderSales,
    'item-promocion': ItemPromocion,
  },
      
  data() {
    return {
      showPopup:false,
      promocion:null,
      cantidadProducto:1, 
      cantValida:true,
    }
  },
            
  computed: {
    items () {
      return this.$store.state.pedido.promociones;
    },
    moneyLabel() {
        if (this.$store.state.pedido.idMoneda == 2) {
          return 'U$S ' 
        }
        else {
          return '$ ' 
        }
    },
    nombrePromo () {
      if (this.promocion != null) {
        return this.promocion.Nombre;
      }
      else {
        return '';
      }
    },
    descripcionPromo () {
      if (this.promocion != null) {
        return this.promocion.Observacion;
      }
      else {
        return '';
      }
    },
    precioPromo () {
      if (this.promocion != null) {
        return (this.conversionMoneda(this.promocion.PrecioPromocional)).toFixed(2);
      }
      else {
        return '';
      }
    },
    limitePromo () {
      if (this.promocion != null) {
        return this.promocion.TieneLimiteMaximo;
      }
      else {
        return false;
      }
    },
    limiteMaxCantPromo () {
      if (this.promocion != null) {
        return this.promocion.LimiteMaximo;
      }
      else {
        return 0;
      }
    },
    tieneUnidadDePedido() {
      if (this.promocion != null) {
        if (this.promocion.UnidadesPorPedido > 1) {
          return true    
        }
        else {
          return false    
        }
      }
      else {
        return false  
      }
    },
    unidadesPorPedido() {
      if (this.promocion != null) {
        return this.promocion.UnidadesPorPedido
      }
      else {
        return ''  
      }
    },
    esMultiploValido() {
      if (this.promocion != null) {
        if (this.cantidadProducto % this.promocion.UnidadesPorPedido == 0) {
          return true  
        } 
        else {
          return false  
        }
      }
      else {
        return true  
      }
    },
    pesoMinimoOk() {
      if (this.promocion != null) {
        if (this.promocion.PesoMinimoPedido > 0) {
          if ((this.cantidadProducto * this.promocion.Peso) < this.promocion.PesoMinimoPedido) {
            return false  
          } 
          else {
            return true  
          }
        }
        else {
          return true    
        }
      }
      else {
        return true  
      }
    },
    valorCercano() {
      if (this.promocion != null) {
        var ent = Math.trunc(this.cantidadProducto/this.promocion.UnidadesPorPedido)  
        var inf = ent * this.promocion.UnidadesPorPedido  
        var sup = (ent+1) * this.promocion.UnidadesPorPedido  
        if (inf<=0) {
            return '(Valor cercano '+sup+')'  
        }
        else {
            return '(Valores cercanos '+inf+' - '+sup+')'  
        }
      }
      else {
        return 0  
      }
    },
    pesoMinimo() {
      if (this.promocion != null) {
        return this.promocion.PesoMinimoPedido
      }
      else {
        return 0  
      }
    },
    pesoPromo () {
      if (this.promocion != null) {
        return this.promocion.Peso;
      }
      else {
        return 0;
      }
    },
    showPesoPromo () {
      if (this.promocion != null) {
          if (this.promocion.PesoMinimoPedido > 0) {
            return true  
          }
          else {
            return false  
          }
      }
      else {
        return false  
      }
    },
    imagenProducto() {
      if ((this.promocion != null)&&(this.promocion.ImagenUrl != null)) {
        return this.promocion.ImagenUrl
      }
      else {
        return '/dist/placeholder-producto.png'
      }
    } 
  },


  methods: {
    updateCantidad() {
      var rex = new RegExp(/^\d+$/);
      if (rex.test(this.cantidadProducto)) {
        if (this.cantidadProducto > 0) {
          if (this.promocion.TieneLimiteMaximo) {
            if (this.cantidadProducto >this.promocion.LimiteMaximo) {
              this.cantValida = false
            }
            else {
              this.cantValida = true
            }
          }
          else {
            this.cantValida = true
          }
        }
        else {
          this.cantValida = false
        }
      }
      else {
        this.cantValida = false
      }
    },

    validar () {
      var rex = new RegExp(/^\d+$/);
      if (!rex.test(this.cantidadProducto)) {
        return false;
      }
      else {
        if (this.cantidadProducto < 1) {
          return false;
        }
        else {
          return true;
        }
      }  
    },

    setPromo (id) {
      this.cantidadProducto = 1
      var promo =  this.$store.state.pedido.promociones.find(e => e.Id == id );
      if (promo != null) {
        this.showPopup = true 
        this.promocion = promo
      }  
    },

    btnAgregarProducto () {
      this.$router.push({name: 'realizarPedidoCat'});
    },

    btnIrCarrito () {
      this.$router.push({name: 'pedido'});
    },

    btnCerrarPopup () {
      this.showPopup = false 
    },

    btnAgregarPopup () {
        var carrito = this.$store.state.pedido.carrito
        var enCarrito = false;
        carrito.forEach((j)=> {
            if (this.promocion.Id === j.id) {
                enCarrito = true
            }
        });
        if (!enCarrito) {
            if (this.validar())
            {
                if (this.promocion.TieneLimiteMaximo && this.cantidadProducto > this.promocion.LimiteMaximo ) {
                var obj = {
                        txt:'La cantidad ingresada supera el límite máximo de unidades de la promoción',
                        txtBtnCancel:'',
                        txtBtnOk:'Aceptar',
                        fCancel:null,
                        fOk:null
                        }
                this.$store.commit('popup/open',obj);
                }
                else {
                    console.log('<2>')
                    console.log(this.promocion)
                    var nuevaPromo = {
                            id: this.promocion.Id,
                            idCategoria: '',
                            idSubcategoria: '',
                            producto: this.promocion.Nombre,
                            descripcion: this.promocion.Observacion, 
                            precio: this.promocion.PrecioHabitual, 
                            precioIngresado: this.promocion.PrecioPromocional, 
                            cantidad: this.cantidadProducto, 
                            peso:this.promocion.Peso,
                            ImagenUrl:this.promocion.ImagenUrl,
                            promocionId:this.promocion.Id,
                            esPromo:true,
                            diasEntrega: this.promocion.DiasEntrega,
                            tieneLimiteMaximo:this.promocion.TieneLimiteMaximo,
                            limiteMaximo:this.promocion.LimiteMaximo,
                            unidadesPorPedido:this.promocion.UnidadesPorPedido,
                            pesoMinimoPedido:this.promocion.PesoMinimoPedido,
                            peso:this.promocion.Peso,
                            tipoOblea:1
                    }
                    this.$store.commit('pedido/agregarAPedido',nuevaPromo);
                    this.showPopup = false 
                }
            }
            else {
                var obj = {
                        txt:'El campo cantidad debe contener un valor numérico entero mayor a 0',
                        txtBtnCancel:'',
                        txtBtnOk:'Aceptar',
                        fCancel:null,
                        fOk:null
                        }
                this.$store.commit('popup/open',obj);
            }
        }
        else {
            var obj = {
                       txt:'La promoción seleccionada ya se encuentra en el carrito de compras, si desea agregar más unidades puede hacerlo desde allí,',
                       txtBtnCancel:'No',
                       txtBtnOk:'Ir al carrito',
                       fCancel:null,
                       fOk:this.irAlCarrito
                      }
            this.$store.commit('popup/open',obj);
        }
    },

    irAlCarrito() {
        this.$router.push({name: 'pedido'});
    },

    conversionMoneda(monto) {
        var montoConv = 0.0
        if (this.$store.state.pedido.idMoneda != this.$store.state.user.cliente.ListaPrecioMoneda) {
            if (this.$store.state.pedido.idMoneda == 2) {
                montoConv  = monto / this.$store.state.user.usuario.CotizacionDolar
            }
            else if (this.$store.state.pedido.idMoneda == 1) {
                montoConv  = monto * this.$store.state.user.usuario.CotizacionDolar
            }
        }
        else {
            montoConv  = monto 
        }
        return montoConv
    }
    
  },

  mounted () {
    this.$store.commit('loader/stop')
  }   
      
}
      
      
</script>
            
<style scoped>
     

#back-popup{
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100vh;
background: #000000;
opacity: 0.6;
filter: alpha(opacity=60); 
}



#popup{
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);
width: 400px;
height: 350px;
border-radius: 15px;
box-sizing: border-box;
background: #ffffff;
border-style: solid;
border-width: 1px;
border: 1px solid #dddddd;
}


#popup-btnClose-container{
  display: flex;            
  flex-direction:row;  
  margin-top: 10px;
  height: 20px;
  padding-right: 10px;
  align-items: center;  
  justify-content: flex-end; 
  background:  #ffffff
}


#popup-titulo{
 font-size: 26px;
 color: #5C666F;
 text-align: center;
}


#popup-container{
  display: flex;            
  flex-direction:row;  
  width: 380px;
  height: 210px;
  background:  #ffffff

}

#popup-image-container{
  width: 160px;
  height: 150px;
  margin-top:20px; 
  display: flex;            
  justify-content: center;  
  align-items: center;

}

#popup-image{
  max-width: 90%;
  max-height: 90%;
}


#popup-producto{
 margin-top: 20px;
 font-size: 15px;
 color: #5C666F;
 font-weight: bold;
}

#popup-descripcion-producto{
 margin-top: 6px;
 font-size: 11px;
 color: #5C666F;
}

#popup-precio-unitario{
 margin-top: 14px;
 margin-bottom: 20px;
 font-size: 24px;
 font-weight: 500;
 color: #5C666F;
}

#popup-cantidad-label{
 font-size: 12px;
 color: #5C666F;
 font-weight: 500;
}

#popup-subtotal-label{
 margin-top: 10px;
 font-size: 12px;
 color: #5C666F;
 font-weight: 500;
}



.popupCantidad{
 font-size: 12px;
 color: #5C666F;
 width: 70px;
 height:20px;
  border-style: solid;
 border-radius: 5px;  
 border:none; 
 border-width: 1px;
 border: 1px solid #dddddd;
 text-align: center;
 outline: none;
}


.popupCantidadInv{
 font-size: 12px;
 color: #5C666F;
 width: 70px;
 height:20px;
  border-style: solid;
 border-radius: 5px;  
 border:none; 
 border-width: 1px;
 border: 1px solid #ff0000;
 text-align: center;
 outline: none;
}


#popup-subtotal{
 font-size: 14px;
 margin-left: 35px;
 font-weight: 600;
 color: #5C666F;
}


#btnContainerPopup{
  height: 80px;
  display: flex;            
  flex-direction: row;  
  justify-content: center;  
  align-items: center;  
}


#btnCerrarPopup{
  width: 100px;
  height: 40px;
  font-size: 10px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;  
  border-style: solid;
  border:none; 
  color: #4969B2;
  background: #ffffff; 
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
}

#btnAgregarPopup{
  width: 160px;
  height: 40px;
  font-size: 10px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;  
  border-style: solid;
  border:none; 
  background: #44C7F4; 
  color: #ffffff;
  outline: none;
}

#btnCerrarPopup:hover { cursor: pointer; }
#btnAgregarPopup:hover { cursor: pointer; }
#btnClose:hover { cursor: pointer; }


.fadePro-enter {
  opacity: 0;
}
.fadePro-enter-active {
  transition: opacity 0.5s;
}
.fadePro-enter-to {
  opacity: 1;
}
.fadePro-leave {
  opacity: 1;
}
.fadePro-leave-active {
  transition: opacity 0.1s;
}
.fadePro-leave-to {
  opacity: 0;
}






/*----------------------------------------------------------------------------------------------------*/
      
       #subheader {
       width: 100%;
       height: 35vh;
       background: linear-gradient(#005A9F , #1899D6);
       }
      
      #main-container{
        position: absolute;
        top: 55vh;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 700px;
        height: 85vh;
        }

        #label-container{
        width: 700px;
        height: 10vh;
        }

        #label{
        color:#ffffff;
        font-size: 27px;
        }

        #container{
        width: 700px;
        height: 65vh;
        padding-top: 35px;
        border-width: 1px;
        border: 1px solid #dddddd;
        box-sizing: border-box;
        /*box-shadow: 3px 3px 4px #dddddd;*/
        background-color: #ffffff;
        display: flex;
        flex-direction:column; 
        align-items: center; 
        }

        #list-container{
        width: 660px;
        height: 55vh;
        background: #ffffff;
        overflow: auto;
        display: flex;
        flex-direction:column; 
        align-items: center; 
        }


        .popupMaximoPorcentaje{
        font-size: 8px; 
        /* font-weight: 10px; */
        color: #5C666F;
        }

        .popupMaximoPorcentajeInv{
        font-size: 8px; 
        /* font-weight: 10; */
        color: #ff0000;
        }




      #btnContainer{
        width: 660px;
        height: 10vh;
        display: flex;
        flex-direction:row; 
        justify-content: flex-end; 
        align-items: center; 
      }

      #btnAgregarProducto{
        width: 120px;
        height: 30px;
        font-size: 9px;
        margin-left: 5px;
        margin-right: 5px;
        border-style: solid;
        border:none; 
        color: #4969B2;
        background: #ffffff; 
        border-radius: 20px;  
        border-width: 1px;
        border: 1px solid #4969B2;
        outline: none;
      }


      #btnIrCarrito{
        width: 100px;
        height: 30px;
        margin-left: 5px;
        margin-right: 5px;
        font-size: 9px;
        border-style: solid;
        border:none; 
        background: #44C7F4; 
        border-radius: 20px;  
        color: #ffffff;
        outline: none;
      }

      #btnAgregarProducto:hover{cursor: pointer;}
      #btnIrCarrito:hover{cursor: pointer;}
          


     /* width */
      ::-webkit-scrollbar {
          width: 5px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
          box-shadow: inset 0 0 5px #dddddd; 
          border-radius: 10px;
      }
      
      /* Handle */
      ::-webkit-scrollbar-thumb {
          background: #bbbbbb; 
          border-radius: 10px;
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
          background: #cccccc; 
      }

      
      
      </style>


// WEBPACK FOOTER //
// src/components/views/promociones/promociones.vue